<template>
  <Fragment>
    <template v-if="$route.name !== 'productTypeIndex'">
      <router-view></router-view>
    </template>
    <section class="container" v-else>
      <Breadcrumb />
      <div class="card-wrap mt-20 mb-20">
        <section class="card-content">
          <div class="left">
            <el-button type="primary" class="mr-20" @click="addProductType"
              >添加区域</el-button
            >
          </div>
          >
        </section>
      </div>
      <el-table :data="list" style="width: 150%" border>
        <el-table-column label="序号" width="110">
          <template slot-scope="scope">
            <span>{{ scope.$index + (pageNum - 1) * pageSize + 1 }}</span>
          </template>
        </el-table-column>
        <el-table-column label="区域名称" width="350">
          <template slot-scope="scope">
            <span>{{ scope.row.typeName }}</span>
          </template>
        </el-table-column>
        <el-table-column label="区域编码" width="350">
          <template slot-scope="scope">
            <span>{{ scope.row.typeCode }}</span>
          </template>
        </el-table-column>
        <el-table-column label="拍码数量" width="200">
          <template slot-scope="scope">
            <span>{{ scope.row.pmCount }}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button size="mini" @click="editProductTypeInfo(scope.row)"
              >编辑</el-button
            >
            <el-button size="mini" @click="salesPerson(scope.row)"
              >售后人员管理</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        class="mt-20 pagination"
        background
        layout="total,prev, pager, next, jumper"
        :total="total"
        :page-size="10"
        :current-page="pageNum"
        @prev-click="handlePrePage"
        @next-click="handleNextPage"
        @current-change="handleCurrentChange"
      >
      </el-pagination>
    </section>
  </Fragment>
</template>

<script>
import { Fragment } from "vue-fragment";

import Breadcrumb from "@/components/Breadcrumb";
export default {
  name: "role",
  components: {
    Breadcrumb,
    Fragment
  },
  data() {
    return {
      typeName: "",
      typeCode: "",
      pmCount: "",
      list: [],
      pageNum: 1,
      pageSize: 10,
      total: 0
    };
  },
  methods: {
    getBaseDataProductTypeList() {
      let _this = this;
      let param = {
        url: "/api/productType/getProductTypeLandingPage",
        params: {
          pageNum: _this.pageNum,
          pageSize: _this.pageSize
        }
      };

      _this.$store.dispatch("getBaseDataProductTypeList", param).then(() => {
        _this.list =
          _this.$store.state.productType.baseDataProductTypeList.list;
        _this.total =
          _this.$store.state.productType.baseDataProductTypeList.total;
      });
    },
    //查询
    searchBaseDataProductTypeInfo() {
      let _this = this;
      _this.getBaseDataProductTypeList();
    },
    //当前页
    handleCurrentChange(value) {
      let _this = this;
      _this.pageNum = value;
      _this.getBaseDataProductTypeList();
    },
    //上一页
    handlePrePage() {
      let _this = this;
      _this.pageNum -= 1;
      _this.getBaseDataProductTypeList();
    },
    //下一页
    handleNextPage() {
      let _this = this;
      _this.pageNum += 1;
      _this.getBaseDataProductTypeList();
    },
    //编辑
    editProductTypeInfo(row) {
      this.$router.push({
        name: "editProductTypeInfo",
        params: { productTypeId: row.productTypeId }
      });
    },
    //售后人员管理
    salesPerson: function(row) {
      this.$router.push({
        name: "salesPersonIndex"
      });
    },
    //添加
    addProductType() {
      this.$router.push({
        name: "addProductTypeInfo"
      });
    }
  },
  created() {
    let _this = this;
    _this.getBaseDataProductTypeList();
  }
};
</script>

<style lang="sass" scoped>
.card-wrap
  .card-content
    display: flex
    align-items: center
    justify-content: space-between
    .left
      display: flex
    .el-button
      font-size: 14px
    .search-name, .search-code
      font-size: 14px
      display: flex
      align-items: center
      span
        white-space: nowrap
.pagination
  text-align: center
</style>
